import * as React from 'react';
import { IconWarning } from '../icons';
import type { DefaultFeedbackProps } from './BaseFeedback';
import { BaseFeedback } from './BaseFeedback';

export const NegativeFeedback: React.FC<React.PropsWithChildren<DefaultFeedbackProps>> = (props) => (
  <BaseFeedback textColor="tw-text-red-800" backgroundColor="tw-bg-red-50" {...props} icon={<IconWarning className="tw-pt-1 tw-h-6" />} />
);
